import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Snackbar, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getUser, login } from '../Redux/Auth/Action';
import Footer from './Footer';

const SignIn = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const jwt = localStorage.getItem('jwt');
    const { auth } = useSelector((store) => store);

    const handleCloseSnackBar = () => setOpenSnackBar(false);

    // Check if user is already authenticated
    useEffect(() => {
        if (jwt) {
            dispatch(getUser(jwt));
        }
    }, [jwt, dispatch]);

    // Show Snackbar if there is a user or an error in the auth state
    useEffect(() => {
        if (auth?.user || auth?.error) {
            setOpenSnackBar(true);
        }
    }, [auth.user, auth.error]);

    if (auth.user) {
        navigate('/home')
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const userData = {
            email: data.get('email'),
            password: data.get('password'),
        };

        console.log('Login user data:', userData);
        dispatch(login(userData));
    };

    return (
        <>
            <Navbar />
            <div className='flex flex-col justify-center items-center h-screen bg-black text-gray-200 pt-32'>
                <div className="w-full max-w-sm p-6 bg-[#1a1a1a] rounded-lg border border-gray-600">
                    <button
                        onClick={() => window.history.back()}
                        className="text-gray-400 border border-gray-400 py-2 px-4 rounded-lg mb-6 hover:bg-[#333] transition text-sm">
                        ← Back
                    </button>
                    <h1 className="text-3xl font-semibold text-white mb-4">Sign In</h1>
                    <p className="text-gray-400 mb-6">
                        Don't have an account?{' '}
                        <a href="/register" className="text-white underline hover:text-gray-300 transition">
                            Sign up
                        </a>
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label htmlFor="email" className="block text-sm font-medium mb-1 text-gray-300">
                                Email*
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="JohnDoe@gmail.com"
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                        </div>
                        <div className="mb-4 relative">
                            <label htmlFor="password" className="block text-sm font-medium mb-1 text-gray-300">
                                Password*
                            </label>
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                id="password"
                                name="password"
                                placeholder="Your Password"
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                            <span
                                onClick={() => setPasswordVisible(!passwordVisible)}
                                className="absolute right-3 top-8 cursor-pointer text-gray-400">
                                {passwordVisible ? '🙈' : '👁'}
                            </span>
                        </div>
                        <div className="flex justify-between items-center mb-6">
                            <label className="flex items-center">
                                <input type="checkbox" className="form-checkbox h-4 w-4 text-gray-600 bg-[#333] rounded-md" />
                                <span className="ml-2 text-sm text-gray-400">Remember me</span>
                            </label>
                            <a href="#" className="text-sm text-gray-400 hover:text-white">Forgot password?</a>
                        </div>
                        <p className="text-gray-500 text-xs text-center mb-1">
                            Fields marked with * are required
                        </p>
                        <button
                            type="submit"
                            className="w-full py-2 bg-white text-black rounded-md hover:bg-gray-200 transition">
                            Sign In
                        </button>
                    </form>
                </div>
            </div>
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleCloseSnackBar} severity={auth.error ? 'error' : 'success'} sx={{ width: '100%' }}>
                    {auth.error ? auth.error : 'Login successful!'}
                </Alert>
            </Snackbar>
            <Footer />
        </>
    );
};

export default SignIn;
